import Vue from "vue";
import Vuex from "vuex";
import tagsView from "./modules/tagsView";

Vue.use(Vuex);

let store = new Vuex.Store({
  modules: {
    tagsView,
  },
});

store.watch(state => state.tagsView.visitedViews,
  visitedViews => {
    visitedViews = visitedViews.map(item => {
      return {
        fullPath: item.fullPath,
        path: item.path,
        name: item.name,
        meta: {
          title: item.meta.title,
          affix: item.meta.affix,
        },
        title: item.title,
        query: item.query,
      };
    });
    const storage = window.localStorage;
    storage.setItem("visitedViews", JSON.stringify(visitedViews));
  },
);

export default store;
